import moment from 'moment';
import DASHBOARD_MOCK from 'mock/dashboard';
import {
  RESET_DASHBOARD,
  GET_DASHBOARD_STATS,
  UPDATE_DASHBOARD_PARAMS,
  GET_TOP_LEADS,
} from '../actions/dashboardActions';

const initialState = {
  loading: true,
  loaded: false,
  interested_by_outlet_type: [],
  interested_by_subject: [],
  dashboardParams: {
    startDate: moment().subtract(30, 'd').local(),
    endDate: moment().local(),
    campaign__id: [],
    subscription_type__id: [],
    product__id: [],
  },
  delivered: 0,
  interested: 0,
  opened: 0,
  people_contacted: 0,
  launched_campaigns: 0,
  report_charts: [],
  topLeads: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
  },
  campaigns: {
    count: null,
    loaded: false,
    loading: true,
    next: null,
    previous: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RESET_DASHBOARD:
      return initialState;
    case GET_DASHBOARD_STATS.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        graphStats: {
          interested_by_outlet_type: [],
          interested_by_subject: [],
        },
      };
    case GET_DASHBOARD_STATS.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        isMocked: !action.payload.data.launched_campaigns,
        ...(!action.payload.data.launched_campaigns ? DASHBOARD_MOCK : action.payload.data),
      };
    case GET_DASHBOARD_STATS.error:
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    case UPDATE_DASHBOARD_PARAMS:
      return {
        ...state,
        dashboardParams: action.payload,
      };
    case GET_TOP_LEADS.pending:
      return {
        ...state,
        topLeads: {
          ...state.topLeads,
          loading: true,
          loaded: false,
        },
      };
    case GET_TOP_LEADS.success:
      return {
        ...state,
        topLeads: {
          ...state.topLeads,
          loading: false,
          loaded: true,
          ...action.payload.data,
        },
      };
    case GET_TOP_LEADS.error:
      return {
        ...state,
        topLeads: {
          loading: false,
          loaded: false,
        },
      };
    default:
      return state;
  }
};
